import { createSlice } from "@reduxjs/toolkit";
import { cascadePermissions } from "../permissionUtils";

export const permissionsSlice = createSlice({
    name: "authorizedPermissions",
    initialState: {
        groupPermissions: undefined,
        layerPermissions: undefined,
        fieldPermissions: undefined,
    },
    reducers: {
        deducePermissions: (state, action) => {
            const [authedRoles, layers, permissions] = action.payload;
            const [groupPermissions, layerPermissions, fieldPermissions] =
                cascadePermissions(authedRoles, layers, permissions);
            state.layerPermissions = layerPermissions;
            state.fieldPermissions = fieldPermissions;
            state.groupPermissions = groupPermissions;
        },
    },
});

export const { deducePermissions } = permissionsSlice.actions;
export default permissionsSlice.reducer;
